import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import TextField from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { useCallback, useEffect, useState } from "react";
import { FC } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";
import getStatesData from "@NA/Handlers/ADIGetStatesRegnForm";
import Select, { SelectProps } from "@insite/mobius/Select";
import loadReturnConfirmedProducts from "@NA/Handlers/ADIReturnConfirmReturnsHandler";
import ADIAddSerialNumbersModal from "@NA/Components/ADIAddSerialNumbersModal";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import Radio from "@NA/MobiusOverrides/Radio";
import { RadioComponentProps, RadioStyle } from "@insite/mobius/Radio";
import loadReturnSelectedOrders from "@NA/Handlers/ADIReturnSelectOrderhandler";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { StateModel, CountryModel, BaseAddressModel } from "@insite/client-framework/Types/ApiModels";
import ADINewAccountAddressSuggestionModalRecap from "@NA/Components/MyAccountRecapPayment/ADINewAccountAddressSuggestionModalLMS";
import { validateAddress } from "@NA/Services/ADIInvoiceRecapBankAccountService";
import WarningIcon from "@NA/Icons/WarningIcon";
import { address } from "@NA/Components/MyAccountRecapPayment/ADINewAccountAddressSuggestionModalRecap";
import { isUSDomain } from "@NA/Utils/Utility";
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        languageId: state.context.session.language?.id,
        email: state.context.session?.email,
        firstName: state.context.session?.firstName,
        lastName: state.context.session?.lastName,
        isAuthenticated: state.context.session?.isAuthenticated,
        ADIRMAConfirmReturns: state?.ADIGlobalData?.ADIRMAConfirmReturns,
        selectedOrderResults: state.ADIGlobalData.ADIRMASelectOrderStore.rmaSelectOrderState,
        countriesDataFromState: getCurrentCountries(state),
    };
};

const mapDispatchToProps = {
    getStatesData,
    loadReturnConfirmedProducts,
    loadReturnSelectedOrders,
};
interface OwnProps {
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    address3: string;
    address4: string;
    country: BaseAddressModel["country"];
    state: BaseAddressModel["state"];
    city: string;
    postalCode: string;
    openModal: boolean;
    closeModal: Function;
    address: address;
    onChangeCountry: (event: React.ChangeEvent<HTMLSelectElement>, country: BaseAddressModel["country"]) => void;
    onChangeState: (event: React.ChangeEvent<HTMLSelectElement>, state: BaseAddressModel["state"]) => void;
    countries: CountryModel[];
}
interface Errors {
    companyName: string;
    city: string;
    address1: string;
    province: string;
    postalCode: string;
}
type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface ReturnOrderStyles {
    container?: InjectableCss;
    accordianContainer?: InjectableCss;
    editHeader?: InjectableCss;
    title?: TypographyProps;
    dataContainer?: GridContainerProps;
    imageContainer?: GridItemProps;
    infoContainer?: GridItemProps;
    returnSelectContainer?: InjectableCss;
    checkbox?: InjectableCss;
    footerBtnWrapper?: InjectableCss;
    continueBtn?: InjectableCss;
    cancelReturn?: InjectableCss;
    disableBtn?: InjectableCss;
    checkboxWrapper?: InjectableCss;
    descriptionText?: InjectableCss;
    smallText?: InjectableCss;
    editLink?: InjectableCss;
    confirmReturnHeader?: InjectableCss;
    desktopProductInfo?: InjectableCss;
    emptySpace?: InjectableCss;
    contactForm?: InjectableCss;
    formGroupHeading?: InjectableCss;
    poNumberWrapper?: InjectableCss;
    contactWrapper?: InjectableCss;
    addressWrapper?: InjectableCss;
    addressGridWrapper?: GridContainerProps;
    contactGridWrapper?: GridContainerProps;
    poGridWrapper?: GridContainerProps;
    shippingChargeMessage?: InjectableCss;
    requiredLabel?: InjectableCss;
    itemWrapper?: InjectableCss;
    item?: InjectableCss;
    warningIcon?: IconPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: InjectableCss;
    confirmReturnGridContainer?: GridContainerProps;
    contactInformationGridItem?: GridItemProps;
    contactInformationStyledWrapper?: InjectableCss;
    subHeadings?: TypographyProps;
    returnRequestHeading?: TypographyProps;
    headingAddressForm?: TypographyProps;
    firstNameGridItem?: GridItemProps;
    city?: GridItemProps;
    state?: GridItemProps;
    lastNameGridItem?: GridItemProps;
    postalCode?: GridItemProps;
    poGridItem?: GridItemProps;
    emailGridItem?: GridItemProps;
    phoneGridItem?: GridItemProps;
    formButtonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    submitButton?: ButtonPresentationProps;
    radioButton?: RadioComponentProps;
    radioGroupDiv?: RadioGroupProps;
    postalCode2GridItem?: GridItemProps;
    shippingMethodGridItem?: GridItemProps;
    formWrapper?: InjectableCss;
    branchLocator?: InjectableCss;
    formSubheading?: InjectableCss;
    formtitleHeading?: InjectableCss;
    RequestSubmit?: InjectableCss;
    fromBottmmessage?: InjectableCss;
    gridStyle?: InjectableCss;
}

export const confirmReturnsStyles: ReturnOrderStyles = {
    submitButton: {
        css: css`
            display: flex;
            margin-top: 30px;
            cursor: pointer;
            pointer-events: default;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },

    shippingChargeMessage: {
        css: css`
            color: ${ADIColors.red1};
            font-weight: bold;
            display: inline-block;
            margin: 1em 0;
            font-size: 12.8px;
        `,
    },
    editHeader: {
        css: css`
            padding: 1rem;
            border: 1px solid #ccc;
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
        `,
    },
    title: {
        css: css`
            font-weight: 700;
            font-size: 20px;
        `,
    },
    imageContainer: {
        width: [12, 12, 2, 2, 2],
        css: css`
            img {
                width: 110px;
                margin: 0 auto;
            }
        `,
    },
    formGroupHeading: {
        css: css`
            font-weight: bold;
            font-size: 14px;
            margin-right: 1rem;
        `,
    },
    accordianContainer: {
        css: css`
            margin-bottom: 40px;
        `,
    },
    infoContainer: {
        width: [12, 12, 4, 4, 4],
        css: css`
            flex-direction: column;
            span {
                display: block;
                font-size: 14px;
            }
            h6 {
                font-weight: 600;
            }
        `,
    },
    footerBtnWrapper: {
        css: css`
            margin-top: 15px !important;
            margin-bottom: 20px !important;
            padding-top: 0px !important;
            display: flex;
            gap: 15px;
            justify-content: center !important;
        `,
    },
    continueBtn: {
        css: css`
            cursor: pointer;
            pointer-events: default;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${ADIColors.lightRed2} !important;
            color: ${ADIColors.white};
            border-color: ${ADIColors.lightRed2} !important;
            :hover {
                background-color: ${ADIColors.lightRed2} !important;
                border-color: ${ADIColors.lightRed2} !important;
            }
        `,
    },
    disableBtn: {
        css: css`
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${ADIColors.gray3};
            color: ${ADIColors.white};
            border-color: ${ADIColors.gray3};
            pointer-events: none;

            :hover {
                background-color: ${ADIColors.gray3};
                border-color: ${ADIColors.gray3};
            }
        `,
    },
    cancelReturn: {
        css: css`
            border-radius: 4px;
            background-color: ${ADIColors.white};
            border-color: ${getColor("primary")};

            :hover {
                background-color: ${ADIColors.white};
                border-color: ${getColor("primary")};
            }
            span {
                color: ${getColor("primary")};
                font-size: inherit !important;
            }
        `,
    },
    returnSelectContainer: {
        css: css`
            padding-top: 0px;
            min-width: 100%;
            display: flex;
            flex-direction: column;
        `,
    },
    contactForm: {
        css: css`
            background-color: #f2f2f2;
            border: solid 1px #e8e8e8;
            padding: 0 9px 0 9px;
            margin-bottom: 1em;

            .poNumber {
                max-width: 100%;
            }

            input {
                height: 2rem !important;
                border-radius: 0 !important;
                font-size: 14px !important;
                padding: 8px !important;
                border: 1px solid #dddddd !important;

                &:focus {
                    outline: none !important;
                    box-shadow: none !important;
                    padding: 8px !important;
                    border: 1px solid #dddddd !important;
                }
            }

            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
            }
            input[type="number"] {
                -moz-appearance: textfield; /* Firefox */
            }
            .contact-heading {
                margin-left: 1.2rem;
            }

            .error-field {
                color: #c60f13;
                label {
                    color: #c60f13 !important;
                }
                input::placeholder {
                    color: #c60f13;
                }
                input {
                    color: #c60f13;
                }
            }

            input {
                color: #060001;
            }

            label {
                font-size: 12.8px;
                color: #060001 !important;
                cursor: default;
                font-weight: normal;
                margin-bottom: -3.5px;
            }

            .state {
                display: flex;
                flex-wrap: wrap;

                span {
                    font-size: 12.8px;
                    color: inherit;
                    cursor: default;
                    margin-bottom: 2.5px;
                }

                svg {
                    top: -8px;
                    position: relative;
                }

                select {
                    border-radius: 0 !important;
                    height: 2rem;
                    margin-top: -5px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 8px !important;
                    border: 1px solid #bbb !important;
                }
            }
        `,
    },
    firstNameGridItem: { width: [12, 12, 6, 6, 6] },
    city: { width: [12, 12, 4, 4, 4] },
    lastNameGridItem: { width: [12, 12, 6, 6, 6] },
    poGridItem: { width: 12 },
    phoneGridItem: { width: 12 },
    emailGridItem: { width: 12 },
    contactGridWrapper: {
        css: css`
            display: inline-flex;
            justify-content: space-between;
            width: 100%;
            margin-left: 2%;

            @media screen and (max-width: 768px) {
                width: 100%;
                flex-wrap: wrap;
            }

            .form-field {
                width: 25%;
                min-width: 23%;

                @media screen and (max-width: 768px) {
                    width: 100%;
                    min-width: 100%;
                }
            }
        `,
    },
    addressGridWrapper: {
        css: css`
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            grid-column-gap: 1rem;
            grid-row-gap: 1.5rem;

            @media screen and (max-width: 1120px) {
                grid-template-columns: repeat(3, 1fr);
            }

            @media screen and (max-width: 768px) {
                grid-template-columns: repeat(2, 1fr);
            }

            @media screen and (max-width: 425px) {
                grid-template-columns: repeat(1, 1fr);
            }

            .form-field {
                min-width: 100%;
                @media screen and (max-width: 1440px) {
                    min-width: max-content;
                }
            }

            .add1,
            .add2 {
                min-width: 330px;

                @media screen and (max-width: 1440px) {
                    min-width: max-content;
                }
            }

            .add2 {
                grid-column-start: 2;
                grid-column-end: 6;

                @media screen and (max-width: 1120px) {
                    grid-column-start: unset;
                    grid-column-end: unset;
                }
            }
        `,
    },
    poNumberWrapper: {
        css: css`
            max-width: 22%;
            display: inline-block;
            @media screen and (max-width: 768px) {
                width: 100%;
                max-width: 100%;
                padding: 0 0.6rem;
            }
        `,
    },
    contactWrapper: {
        css: css`
            display: inline-block;
            width: 78%;
            padding: 0 1rem 0 0;

            @media screen and (max-width: 768px) {
                width: 100%;
            }
        `,
    },
    addressWrapper: {
        css: css`
            margin-top: 1rem;
        `,
    },
    requiredLabel: {
        css: css`
            display: block;
            margin: 1.5rem;
            text-align: right;
        `,
    },
    itemWrapper: {
        css: css`
            width: 100%;
        `,
    },
    item: {
        css: css`
            width: 25%;
            display: inline-block;
        `,
    },
    dataContainer: {
        css: css`
            padding-top: 20px;
            padding-bottom: 20px;
        `,
    },
    warningIcon: {
        src: "AlertCircle",
        color: "danger.main",
        css: css`
            margin-right: 10px;
        `,
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            padding: 30px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    confirmReturnGridContainer: {
        css: css`
        margin: 0 auto,
        max-width:500px,
            > ${GridOffset} {
                margin: 0 auto,
        max-width:500px,
                > ${GridItemStyle} {
                    padding-bottom: 5px;
                }
            }
        `,
    },
    subHeadings: {
        css: css`
            color: ${ADIColors.darkBlue1};
            font-size: 24px;
            line-height: normal;
            margin-top: 0;
            font-weight: bold !important;
            text-align: center;
            width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 20px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    contactInformationGridItem: {
        width: 6,
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    contactInformationStyledWrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            padding-top: 40px;
            align-items: center;
            gap: 18px;
            > ${FormFieldStyle} {
                max-width: 420px;
                ${FormInputWrapper} {
                    margin-top: 0px !important;
                }
            }
            input {
                height: 38px !important;
                color: #939393 !important;
            }
        `,
    },
    shippingMethodGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    formButtonsWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            margin-top: 30px;
        `,
    },
    cancelButton: {
        color: "secondary",
        css: css`
            margin-right: 10px;
        `,
    },
    formWrapper: {
        css: css`
            margin: 0 auto;
            max-width: 625px;
            border: solid 1px #e8e8e8;
            padding: 40px 30px;
            background: #f7f7f7;
            border-radius: 6px;
        `,
    },
    branchLocator: {
        css: css`
            margin-left: 15px;
        `,
    },
    radioGroupDiv: {
        css: css`
            flex-direction: column;
            > ${RadioStyle} {
                > input {
                    margin: 0px 1px;
                }
                > label {
                    font-size: 16px;
                }
            }
            > ${RadioStyle} + ${RadioStyle} {
                margin-top: 16px;
            }
        `,
    },
    formSubheading: {
        css: css`
            text-align: center;
            width: 100%;
        `,
    },
    formtitleHeading: {
        css: css`
            font-size: 19px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.05;
            letter-spacing: normal;
            text-align: left;
            color: #2d2926;
            text-align: center;
            text-transform: capitalize;
            padding: 0px 0 5px 0;
        `,
    },
    RequestSubmit: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 10px;
        `,
    },
    headingAddressForm: {
        css: css`
            color: ${ADIColors.darkBlue1};
            font-size: 19px;
            line-height: normal;
            margin-top: 0;
            font-weight: bold !important;
            width: 100%;
            margin-left: 100px;
            margin-bottom: 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 20px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    returnRequestHeading: {
        css: css`
            color: ${ADIColors.darkBlue1};
            font-size: 19px;
            line-height: normal;
            margin-top: 0;
            font-weight: bold !important;
            width: 100%;
            text-align: center;
            margin-bottom: 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 20px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    fromBottmmessage: {
        css: css`
            display: flex;
            margin-top: 16px;
            font-size: 14px;
        `,
    },
    gridStyle: {
        css: css`
            display: inline-grid;
            gridtemplatecolumns: auto auto;
            justifycontent: center;
            columngap: 50px;
        `,
    },
};

const styles: any = confirmReturnsStyles;

let ProvinceName= "Province";
 let PostalCodeName="Postal Code*";
 let PlaceholderName="A1A A1A";
  if (isUSDomain()) {
        ProvinceName = "State";
        PostalCodeName="Zip Code*";
        PlaceholderName="12345";
     }

const ProductInfo = ({ eachProduct, hasExistingReturns, shippingMethod, selectedOrderResults }: any) => {
    const {
        selection: {
            adonisDate,
            adonisSeq,
            defectReason,
            description,
            option,
            orderNumber,
            partNumber,
            qty,
            returnReason,
            serialNumbers: serialNumbersProps,
            techRA,
            type,
            error: {
                adonisDate: isadonisDate,
                adonisSeq: isadonisSeq,
                defectReason: isdefectReason,
                description: isDescription,
                option: isCustomerResponse,
                orderNumber: isorderNumber,
                partNumber: ispartNumber,
                qty: isqty,
                returnReason: isreturnReason,
                serialNumbers: isserialNumbers,
                techRA: isTechRA,
                type: istype,
            },
        },
    } = eachProduct;

    const [isAddSerialNumbersModalOpen, setIsAddSerialNumbersModalOpen] = useState(false);
    const [serialNumbers, setSerialNumberData] = useState<any>(serialNumbersProps || []);
    const [addressApiResult, setAddressApiResult] = useState<any>([]);
    const [isAddressSuggestionModalOpen, setIsAddressSuggestionModalOpen] = useState(false);
    const showSerialNumberModal = () => {
        setIsAddSerialNumbersModalOpen(true);
    };

    const onSerialNumberModalClose = () => {
        setIsAddSerialNumbersModalOpen(false);
    };

    const getTypeLabel = () => {
        if (type === "NN") {
            return "Credit - New";
        }
        if (type === "CR") {
            return "Credit - Defective Item";
        }
        if (type === "RR") {
            return "Repair";
        }
        if (type === "RX") {
            return "Exchange - Defective Item";
        }
        return "";
    };

    const customerResponseMessage = () => {
        const message = eachProduct?.custOptions?.find((item: any) => {
            if (item.type == type) {
                return item;
            }
        });
        return message?.options[option - 1]?.label;
    };

    const handleSerialNumberChange = (newValue: any) => {
        const productsSelectedForReturn = sessionStorage.getItem("productsToBeReturned")!;

        let productData: any = [];
        productData = sessionStorage.getItem("productsToBeReturned");
        if (productData) {
            productData = JSON.parse(productData);
            const updatedProductData = productData?.map((item: any) => {
                return { ...item, selection: { ...item.selection, serialNumbers: newValue } };
            });

            setSerialNumberData(newValue);
            sessionStorage.setItem("productsToBeReturned", JSON.stringify(updatedProductData));
        }
    };

    return (
        <>
            <GridItem {...styles.returnSelectContainer}>
                <StyledWrapper {...styles.itemWrapper}>
                    <Typography {...styles.item}>{translate("Returning")}:</Typography>
                    <Typography>{qty}</Typography>
                </StyledWrapper>

                <StyledWrapper {...styles.itemWrapper}>
                    <Typography {...styles.item}>{translate("Order:")}</Typography>
                    <Typography>{orderNumber}</Typography>
                </StyledWrapper>

                <StyledWrapper {...styles.itemWrapper}>
                    <Typography {...styles.item}>{translate("Reason for Return")}:</Typography>
                    <Typography>{translate(getTypeLabel())}</Typography>
                </StyledWrapper>

                {techRA && (
                    <StyledWrapper {...styles.itemWrapper}>
                        <Typography {...styles.item}>Tech RA #</Typography>
                        <Typography>{techRA}</Typography>
                    </StyledWrapper>
                )}
                {serialNumbers.length !== 0 && (
                    <StyledWrapper {...styles.itemWrapper}>
                        <Typography {...styles.item}>{translate("Serial #")}</Typography>
                        <>
                            [
                            {serialNumbers &&
                                serialNumbers.map((item: any, index: any) => {
                                    return (
                                        <Typography key={item + index}>
                                            {item} {serialNumbers.length - 1 == index ? null : ","}
                                        </Typography>
                                    );
                                })}
                            ]
                            {shippingMethod === "takereturn" && (
                                <Link
                                    style={{ marginLeft: "15px" }}
                                    onClick={() => {
                                        showSerialNumberModal();
                                    }}
                                    {...styles.editLink}
                                >
                                    EDIT
                                </Link>
                            )}
                        </>
                    </StyledWrapper>
                )}

                {isCustomerResponse && (
                    <>
                        <Typography style={{ fontWeight: "bold" }}>
                            {translate("How would you like to respond if a vendor denies the warranty repair request")}
                        </Typography>
                        <Typography>{customerResponseMessage()}</Typography>
                    </>
                )}
                {description && <Typography>{description}</Typography>}
            </GridItem>

            <ADIAddSerialNumbersModal
                isAddSerialNumbersModalOpen={isAddSerialNumbersModalOpen}
                serialNumbersFields={serialNumbers}
                onSerialNumberModalClose={onSerialNumberModalClose}
                handleSerialNumberChange={handleSerialNumberChange}
            />
        </>
    );
};

const FormError = ({ returnId }: any) => {
    return (
        <>
            <Typography style={{ marginBottom: "20px", color: ADIColors.red1 }}>
                <Icon {...styles.warningIcon}></Icon>
                {translate("There was an issue processing your online return. Please visit")}{" "}
                <a href="/dealerlocator" target="_blank" style={{ color: ADIColors.blue1 }}>
                    {translate("your local branch")}
                </a>{" "}
                {translate("to process your return or ship it back to us using our")}{" "}
                <a href="/MyAccount/returns" target="_blank" style={{ color: ADIColors.blue1 }}>
                    {translate("return instructions")}
                </a>{" "}
                {translate("Use the Web Return ID as your reference number")} {returnId}
                {translate(". We apologize for the inconvenience.")}
            </Typography>
        </>
    );
};

export const ADIReturnSelectOrder: FC<Props> = ({
    languageId,
    getStatesData,
    loadReturnConfirmedProducts,
    email,
    firstName,
    lastName,
    isAuthenticated,
    ADIRMAConfirmReturns,
    selectedOrderResults,
    loadReturnSelectedOrders,
    countriesDataFromState,
    onChangeCountry,
    closeModal,
    openModal,
    address,
}) => {
    useEffect(() => {
        let selectedOrdersList: any = sessionStorage.getItem("selectedOrdersList")!;
        if (!selectedOrdersList) return;

        selectedOrdersList = JSON.parse(selectedOrdersList);
        let returnSelectOrderIDs = selectedOrdersList?.map((eachOrder: any) => eachOrder.webOrderNumber);

        if (returnSelectOrderIDs?.length) {
            loadReturnSelectedOrders({
                orders: [...returnSelectOrderIDs],
            });
        }
    }, []);

    useEffect(() => {
        if (selectedOrderResults) {
            setPoSyntax(selectedOrderResults?.orders[0]?.poSyntax);
        }
    }, [selectedOrderResults]);
    const history = useHistory();
    const getContactForm = () => {
        const contactFormFields = [
            {
                label: translate("PO Number*"),
                required: true,
                placeholder: translate("Enter PO Number"),
                type: "text",
                maxLength: 20,
                value: "",
                key: "poNumber",
                group: "po",
                error: false,
                style: "poGridItem",
                errormessage: "This field is required",
            },
            {
                label: "First Name*",
                required: true,
                placeholder: "Enter First Name",
                type: "text",
                maxLength: 20,
                key: "fname",
                value: firstName ? firstName : "",
                group: "po",
                error: false,
                style: "firstNameGridItem",
                errormessage: "This field is required",
            },
            {
                label: "Last Name*",
                required: true,
                placeholder: "Enter Last Name",
                type: "text",
                maxLength: 20,
                value: lastName ? lastName : "",
                key: "lname",
                group: "po",
                error: false,
                style: "lastNameGridItem",
                errormessage: "This field is required",
            },
            {
                label: "Email Address*",
                required: true,
                placeholder: "Enter Email Address",
                type: "email",
                maxLength: 50,
                value: email ? email : "",
                key: "email",
                group: "po",
                error: false,
                style: "emailGridItem",
                errormessage: "This field is required",
            },
            {
                label: "Business Phone*",
                required: true,
                placeholder: "Enter Phone (10 digit)",
                type: "number",
                maxLength: 10,
                value: "",
                key: "phone",
                group: "po",
                error: false,
                style: "phoneGridItem",
                errormessage: "This field is required",
            },
            {
                label: translate("Street Address*"),
                required: true,
                placeholder: translate("Street Address"),
                type: "text",
                maxLength: 30,
                value: "",
                key: "add1",
                group: "address",
                error: false,
                style: "poGridItem",
            },
            {
                label: translate("Street Address 2"),
                required: false,
                placeholder: translate("Street Address"),
                type: "text",
                maxLength: 30,
                value: "",
                key: "add2",
                group: "address",
                error: false,
                style: "poGridItem",
            },
            {
                label: "City*",
                required: true,
                placeholder: "City",
                type: "text",
                maxLength: 20,
                value: "",
                key: "city",
                group: "address",
                error: false,
                style: "city",
            },
            {
                label: ProvinceName,
                required: true,
                type: "dropdown",
                value: "",
                key: "state",
                group: "address",
                error: false,
                style: "city",
                placeholder: "Chose A State",
            },
            {
                label: PostalCodeName,
                required: true,
                type: "text",
                value: "",
                key: "zip",
                group: "address",
                error: false,
                maxLength: 6,
                placeholder: PlaceholderName,
                style: 'city'
            },
            {
                label: translate("Number of Cartons*"),
                required: true,
                placeholder: "# (max 15)",
                type: "number",
                max: 15,
                maxLength: 2,
                value: "",
                key: "cartons",
                group: "address",
                error: false,
                style: "firstNameGridItem",
            },
            {
                label: translate("Estimated Total Weight of Cartons*"),
                required: true,
                placeholder: translate("Weight in lbs (max 60)"),
                type: "number",
                max: 60,
                maxLength: 3,
                value: "",
                key: "cartonsWeight",
                group: "address",
                error: false,
                style: "lastNameGridItem",
            },
        ];
        return contactFormFields;
    };
    const [productsToBeReturned, setProductsToBeReturned] = useState([]);
    const [isFormValid, setIsFormValid] = useState(false);
    const [statesData, setStatesData] = useState([]);
    const [postalCodeMaxLength, setpostalCodeMaxLength] = React.useState<number>(6);
    const [contactForm, setContactForm] = useState(getContactForm());
    const [isApiError, setIsApiError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [shippingMethod, setShippingMethod] = useState("takereturn");
    const [poSyntax, setPoSyntax] = useState("");
    const [isValidPO, setIsValidPO] = useState(true);
    const [shipToForm, setshipToForm] = useState<boolean>(false);
    const [returnToBranch, setreturnToBranch] = useState<boolean | string>(true);

    const [addressApiResult, setAddressApiResult] = useState<any>([]);
    const [isAddressSuggestionModalOpen, setIsAddressSuggestionModalOpen] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState<CountryModel | undefined>(undefined);
    const [states, setStates] = useState<StateModel[]>([]);
    const [countrydata, setCountry] = useState<any>();
    const [countrytate, setCountryState] = useState([]);
    const [selectedState, setSelectedState] = useState<any>("");
    const [suggestionWraningMessage, setSuggestionWraningMessage] = useState<string>("");
    const [isApiErrorMessage, setIsApiErrorMessage] = useState("");
    const [errors, setErrors] = useState<Errors>({
        companyName: "",
        city: "",
        address1: "",
        province: "",
        postalCode: "",
    });
    const [addressValidationErrorMessage, setAddressValidationErrorMessage] = useState<string[]>([]);
    const [addressFormData, setAddressFormData] = useState(address);
    const [number_Po_business, setnumber_Po_business] = useState<{ ponumber: string; phone: string }>(
        JSON.parse(sessionStorage.getItem("po_Business_number") || "{}"),
    );
   useEffect(() => {
        if (window) {
            window.scrollTo(0, 0);
        }
    }, []);
    // useEffect(() => {
    //     setSelectedCountry(countries.find(c => c.id === country?.id));
    // }, [country]);

    useEffect(() => {
        setStates(selectedCountry?.states || []);
    }, [selectedCountry]);

    const handleStateChange: SelectProps["onChange"] = event => {
        let selectedValue = event.target.value;
        const state: any = countrytate?.find((s: any) => s.name == selectedValue);
        selectedValue = state?.abbreviation;
        setSelectedState(state);
        contactForm[8].value = selectedValue;
        // onChangeState(event, state || null);
    };

    let submitRequest: any;
    useEffect(() => {
        setIsLoading(ADIRMAConfirmReturns?.isLoading);
        if (ADIRMAConfirmReturns?.rmaConfirmReturnState) {
            if (ADIRMAConfirmReturns?.rmaConfirmReturnState?.isSuccessFlag && ADIRMAConfirmReturns?.isSuccess) {
                 setIsApiError(false);
                sessionStorage.setItem(
                    "ADIRMAConfirmReturns",
                    JSON.stringify(ADIRMAConfirmReturns?.rmaConfirmReturnState),
                );
                let submitReq: any = sessionStorage.getItem("returnSubmitRequest");
                if(submitReq) {
                    submitRequest = JSON.parse(submitReq);
                }
                if (submitRequest?.contact?.method === "Pickup") {
                    // history.push("/MyAccount/Returns/Confirmation");
                    history.push("/MyAccount/Returns/Confirmation");
                } else if (submitRequest?.contact?.method === "Shipped") {
                    if (returnToBranch) {
                        setshipToForm(false);
                    }
                }
            } else {
                setIsApiError(true);
            }
        }
    }, [ADIRMAConfirmReturns]);

    useEffect(() => {
        let productsSelectedForReturn: any = sessionStorage.getItem("productsToBeReturned");
        productsSelectedForReturn = JSON.parse(productsSelectedForReturn);
        setProductsToBeReturned(productsSelectedForReturn);
    }, []);
    React.useEffect(() => {
        if (languageId) {
            getStatesData({
                languageId,
                expand: "states",
                onSuccess: (result: any) => {
                    const locationsData = result.result?.countries[0];
                    const states = locationsData.states;
                    const country = locationsData.name;
                    setStatesData(states ?? []);
                    const countryAbbreviation = locationsData.abbreviation;
                    if (countryAbbreviation) {
                        switch (countryAbbreviation) {
                            case "CA":
                                setpostalCodeMaxLength(6);
                                break;
                            default:
                                // US,PR
                                setpostalCodeMaxLength(5);
                                break;
                        }
                    }
                },
                onComplete(result) {
                    setCountry(result.apiResult?.result?.countries[0]);
                    setCountryState(result.apiResult?.result?.countries[0].states);
                    if (result.apiResult) {
                        this.onSuccess?.(result.apiResult);
                    }
                },
            });
        }
    }, []);

    const validateFields = (key: string, value: any) => {
        const emailRegexPattern =
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

        if (key === "poNumber" && value == "") {
            return false;
        }
        else if (key === "email" && !emailRegexPattern.test(value)) {
            return false;
        } else if (key === "phone" && value.length < 10) {
            return false;
        }
        return true;
    };
    const parsePoSyntax = (po: string) => {
        let poArray = [],
            poArrayObj = {},
            lastChar = "",
            sameCharCnt = 0;

        for (let i = 0; i < po.length; i++) {
            let thisChar = po[i],
                poArrayPntr: any = poArray.length - 1;
            sameCharCnt = thisChar === lastChar ? ++sameCharCnt : 1;

            switch (thisChar) {
                case "@":
                case "#":
                    if (sameCharCnt != 1) {
                        poArray[poArrayPntr] = { c: thisChar, n: sameCharCnt };
                    } else {
                        poArray.push({ c: thisChar, n: sameCharCnt });
                    }
                    break;
                default:
                    poArray.push({ c: thisChar, n: sameCharCnt });
                    break;
            }
            lastChar = po[i];
        }
        return poArray;
    };

    // Convert POSyntax format to a RegExp
    const poSyntaxToRegexStr = (po: string) => {
        let sa = parsePoSyntax(po),
            rx = "^";
        if (poSyntax == "") {
            return rx;
        }
        // build regex
        for (let i = 0; i < sa.length; i++) {
            let o = sa[i],
                n = o.n,
                c = o.c,
                v = "";

            switch (c) {
                case " ":
                    rx += "\\s";
                    break;
                case "@":
                    rx += "[a-zA-Z]";
                    break;
                case "#":
                    rx += "\\d";
                    break;
                case "*":
                    rx += "[a-zA-Z0-9]";
                    break;
                case "^":
                    rx += ".+";
                    break;
                default:
                    //rx += '[A-Z0-9]'; '['+c+']';
                    rx += "[" + c + "]"; //'[.]';
                    break;
            }
            rx += n > 1 ? "{" + n + "}" : "";
        }
        rx += "$";
        return rx;
    };

    // Test if string matches POSyntax format
    const isValid = (poSyntax: string, poValue: string) => {
        let rs = poSyntaxToRegexStr(poSyntax),
            rx = new RegExp(rs);
        return rx.test(poValue);
    };
    const getFormatExample = () => {
        let tempLblExmpl = "";
        if (poSyntax == "") {
            return tempLblExmpl;
        }
        let ary = parsePoSyntax(poSyntax);

        const getSecureRandom = () => {
            const array = new Uint32Array(1);
            crypto.getRandomValues(array);
            return array[0] / (0xffffffff + 1);
        };

        let letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
            numbers = "1234567890",
            ln = letters.concat(numbers),
            mx = ln
                .split("")
                .sort(function () {
                    return 0.5 - getSecureRandom();
                })
                .join("");
        for (let i = 0; i < ary.length; i++) {
            let itm = ary[i];
            switch (itm["c"]) {
                case "@":
                    tempLblExmpl += letters.substring(0, itm["n"]);
                    break;
                case "#":
                    tempLblExmpl += numbers.substring(0, itm["n"]);
                    break;
                case "*":
                    tempLblExmpl += mx.substring(0, itm["n"]);
                    break;
                case "^":
                    let min = 1,
                        max = 4,
                        cnt = Math.floor(getSecureRandom() * (max - min + 1)) + min;
                    tempLblExmpl += mx.substring(0, cnt);
                    break;
                default:
                    tempLblExmpl += "" + itm["c"];
                    break;
            }
        }
        return tempLblExmpl;
    };
    const validatePO = (val: string) => {
        const _out = isValid(poSyntax, val);
        if (_out) setIsValidPO(true);
        else setIsValidPO(false);
        return _out;
    };
    const handleFormFieldChange = (key: string, value: any) => {
        const contactFormCopy = [...contactForm];
        const currentField: any = contactFormCopy.find(eachField => eachField.key === key);
        if (key === "poNumber") {
            const isValidPo = validatePO(value);
            setIsValidPO(isValidPo);
        }
        if (key === "phone") {
            const inputText = parseInt(value);
            if (value.length <= 10) {
                if (isNaN(inputText)) {
                    currentField.value = "";
                } else {
                    currentField.value = inputText;
                }
            }
        }
        if (!currentField) return;
        if (currentField.maxLength && value.length > currentField.maxLength) return;
        if (key !== "phone") currentField.value = value;

        if (key === "cartons") {
            value <= currentField.max ? (currentField.value = value) : (currentField.value = currentField.max);
        }

        if (key === "cartonsWeight") {
            value <= currentField.max ? (currentField.value = value) : (currentField.value = currentField.max);
        }
        const trimmedValue = value.trim();
        const isFieldValid = validateFields(key, trimmedValue);
        currentField.error = !isFieldValid;
        setContactForm(contactFormCopy);
    };

    const getSelections = () => {
        let optionValue_data = sessionStorage.getItem("option_data_value");
        const productsSelectedForReturn = sessionStorage.getItem("productsToBeReturned")!;

        let productData: any = [];
        productData = sessionStorage.getItem("productsToBeReturned");

        if (productData) {
            productData = JSON.parse(productData);

            const selectionData = productData?.map((item: any) => {
                const { selection, invoice_no, sequence, PoSyntax } = item;
                const { error: _, ...rest } = selection;
                rest.invoice_no = invoice_no;
                rest.sequence = sequence;
                rest.PoSyntax = "";
                rest.customer_disp = optionValue_data === "" ? "" : optionValue_data;
                rest.defectReason = selection.type == "NN" ? selection.returnReason : selection.defectReason;
                rest.description =
                    rest.option == "Call with estimate if repair charge is over $250.00 (per item)."
                        ? "Call over $250.00/item, " + `${rest.description}`
                        : rest.description;
                return rest;
            });

            return selectionData;
        }
        return [];
    };

    useEffect(() => {
        getSelections();
    }, []);

    const compareAddresses = (originalAddress: any, propsedAddress: any) => {
        // Check if all relevant fields are the same
        return (
            (originalAddress.address1 === propsedAddress.address1 &&
                originalAddress.address2 === propsedAddress.address2 &&
                originalAddress.address3) ||
            ("" === propsedAddress.address3 &&
                originalAddress.city.toUpperCase() === propsedAddress.city.toUpperCase() &&
                originalAddress.state.abbreviation.toUpperCase() === propsedAddress.stateProv.toUpperCase() &&
                originalAddress.postalCode === propsedAddress.postalCode.split("-")[0] &&
                originalAddress.country.abbreviation.toUpperCase() === propsedAddress.country.toUpperCase())
        );
    };

    const getTrimmedFormValues = () => {
        return contactForm.map(field => ({
            ...field,
            value: typeof field.value === "string" ? field.value.trim() : field.value,
        }));
    };

    const HandleValidateAddress = async (modelOpen: boolean) => {
        const trimmedForm = getTrimmedFormValues();
        const payload = {
            country: countrydata,
            state: selectedState,
            address1: trimmedForm[5].value.toUpperCase(),
            address2: trimmedForm[6].value.toUpperCase(),
            city: trimmedForm[7].value.toUpperCase(),
            postalCode: trimmedForm[9].value,
        };
        const commonValidationErrors = [
            translate("Street Not Validated"),
            translate("City/State Not Validated"),
            translate(`${PostalCodeName} Not Validated`),
        ];
        const address = await validateAddress(payload).then(result => {
            if (result.successful) {
                setIsLoading(false);
                setIsApiErrorMessage("");
                if (result.result?.proposedAddress === "" || result.result?.proposedAddress === null) {
                    setIsApiErrorMessage(translate("The entered address is invalid. Please enter a valid address."));
                } else if (
                    result.result?.proposedAddress?.validationScore >= 80 &&
                    result.result?.proposedAddress?.validated === "Y"
                ) {
                    if (result.result.validationMessage === "") {
                        const comparisionResult = compareAddresses(
                            result.result?.originalAddress,
                            result.result?.proposedAddress,
                        );

                        if (comparisionResult) {
                            addAccount();
                        } else {
                            setAddressApiResult(result);
                            setIsAddressSuggestionModalOpen(true);
                            setSuggestionWraningMessage("");
                            setIsApiErrorMessage("");
                            setErrors({
                                companyName: "",
                                city: "",
                                address1: "",
                                province: "",
                                postalCode: "",
                            });
                        }
                    }
                } else if (
                    result.result?.proposedAddress?.validationScore < 80 &&
                    result.result?.proposedAddress?.validated === "Y"
                ) {
                    if (result.result.validationMessage !== "") {
                        const validationError = result.result.validationMessage
                            ?.split(";")
                            .filter((ele: string) => ele !== " ");
                        const isOtherError = validationError.every((element: string) =>
                            commonValidationErrors.includes(element.trim()),
                        );
                        if (!isOtherError) {
                            setAddressValidationErrorMessage(["Suite Number Not Validated"]);
                        } else {
                            const updatedErrors: any = { ...errors };
                            validationError.forEach((message: string) => {
                                let fieldName: string = "";
                                let errorMessage: string = "";

                                if (message.toLowerCase().includes("street")) {
                                    fieldName = "address1";
                                    errorMessage = " ";
                                } else if (message.toLowerCase().includes("city/state")) {
                                    fieldName = "city";
                                    errorMessage = " ";
                                } else if (message.toLowerCase().includes("postal")) {
                                    fieldName = "postalCode";
                                    errorMessage = " ";
                                }
                                if (fieldName && errorMessage) {
                                    updatedErrors[fieldName] = errorMessage;
                                }
                            });
                            setErrors(updatedErrors);
                            setAddressValidationErrorMessage(validationError);
                        }
                    } else {
                        closeModal();
                        setIsApiErrorMessage("");
                        setAddressApiResult(result);
                        setIsAddressSuggestionModalOpen(true);
                        setSuggestionWraningMessage(
                            translate(
                                "Unable to Validate address. Please choose whether you want to use the address you provided or the one we suggest",
                            ),
                        );
                        setErrors({
                            companyName: "",
                            city: "",
                            address1: "",
                            province: "",
                            postalCode: "",
                        });
                    }
                }
            }
        });
    };

    const submitHandler = async () => {

        const trimmedForm = getTrimmedFormValues();
        sessionStorage.setItem(
            "po_Business_number",
            JSON.stringify({ ponumber: trimmedForm[0].value, phone: trimmedForm[4].value }),
        );
        let contactFormCopy = [...trimmedForm];

        {trimmedForm.map((item) => {
            const error = validateFields(item.key, item.value);
            return error;
          })}

        contactFormCopy = contactFormCopy.map(eachField => {
            return {
                ...eachField,
                error: !eachField.value && eachField.key !== "add2",
            };
        });
        setContactForm(contactFormCopy);
        const invalidFields = contactFormCopy.filter(eachField => eachField.error && eachField.group === "po");
        if (invalidFields.length === 0) {
            setIsFormValid(true);
            debugger;
            const payloadResponse = {
                contact: {
                    po: trimmedForm[0].value,
                    email: trimmedForm[3].value,
                    firstName: trimmedForm[1].value,
                    lastName: trimmedForm[2].value,
                    phone: trimmedForm[4].value,
                    shipFromName: "",
                    shipFromAddress1: trimmedForm[5].value,
                    shipFromAddress2: trimmedForm[6].value,
                    shipFromCity: trimmedForm[7].value,
                    shipFromStateProv: trimmedForm[8].value,
                    shipFromPostalCode: trimmedForm[9].value,
                    cartons: contactForm[10].value,
                    cartonWeight: contactForm[11].value,
                    method: shippingMethod === "Shipped" ? "Shipped" : "Pickup",
                    webUserId: "",
                    salesLocId: "",
                    webUserEmail: "",
                    webReference: "",
                    // saveMethod: shippingMethod === 'Shipped' ? "RMA Submit" : 'Shipped',
                    saveMethod: "RMA Submit",
                    returnID: "",
                },
                selections: getSelections(),
            };
            sessionStorage.setItem("returnSubmitRequest", JSON.stringify(payloadResponse));
            loadReturnConfirmedProducts({ payloadResponse });
            setreturnToBranch(false);
           if(payloadResponse?.contact?.method === "Shipped") {
             setshipToForm(true)
           }
        }
        return false;
    };

    const getFieldsByType = (group: string) => {
        return contactForm.filter(eachField => eachField.group === group);
    };

    const poFields = getFieldsByType("po");
    const contactFields = getFieldsByType("contact");
    const addressFields = getFieldsByType("address");
    const addAccount = async () => {
        let productsSelectedForReturn: any = sessionStorage.getItem("productsToBeReturned");
        productsSelectedForReturn = JSON.parse(productsSelectedForReturn);
        setIsLoading(true);
        const trimmedForm = getTrimmedFormValues();
        const payloadResponse = {
            contact: {
                po: trimmedForm[0].value,
                email: trimmedForm[3].value,
                firstName: trimmedForm[1].value,
                lastName: trimmedForm[2].value,
                phone: trimmedForm[4].value,
                shipFromName: "",
                shipFromAddress1: trimmedForm[5].value,
                shipFromAddress2: trimmedForm[6].value,
                shipFromCity: trimmedForm[7].value,
                shipFromStateProv: trimmedForm[8].value,
                shipFromPostalCode: trimmedForm[9].value,
                cartons: trimmedForm[10].value,
                cartonWeight: trimmedForm[11].value,
                method: shippingMethod === "Shipped" ? "Shipped" : "Pickup",
                webUserId: "",
                salesLocId: "",
                webUserEmail: "",
                webReference: "",
                // saveMethod: shippingMethod === 'Shipped' ? "RMA Submit" : 'Shipped',
                saveMethod: "Shipping Label",
                returnID: ADIRMAConfirmReturns?.rmaConfirmReturnState?.returnId || "",
            },
            selections: getSelections(),
        };
        loadReturnConfirmedProducts({ payloadResponse });

        sessionStorage.setItem("saveMethodLabel", "Shipping Label");
        history.push("/MyAccount/Returns/Confirmation");
        setIsLoading(false);
    };
    const proposedAddress = async (proposedAddress: any) => {
        let productsSelectedForReturn: any = sessionStorage.getItem("productsToBeReturned");
        productsSelectedForReturn = JSON.parse(productsSelectedForReturn);
        setIsLoading(true);
        debugger;
        const payloadResponse = {
            contact: {
                po: contactForm[0].value,
                email: contactForm[3].value,
                firstName: contactForm[1].value,
                lastName: contactForm[2].value,
                phone: contactForm[4].value,
                shipFromName: "",
                shipFromAddress1: proposedAddress?.address1,
                shipFromAddress2: proposedAddress?.address2,
                shipFromCity: proposedAddress?.city,
                shipFromStateProv: proposedAddress?.stateProv,
                shipFromPostalCode: proposedAddress?.postalCode,
                cartons: contactForm[10].value,
                cartonWeight: contactForm[11].value,
                method: "Shipped",
                webUserId: "",
                salesLocId: "",
                webUserEmail: "",
                webReference: "",
                saveMethod: "Shipping Label",
                returnID: ADIRMAConfirmReturns?.rmaConfirmReturnState?.returnId || "",
            },
            selections: getSelections(),
        };
        loadReturnConfirmedProducts({ payloadResponse });
        sessionStorage.setItem("saveMethodLabel", "Shipping Label");
        history.push("/MyAccount/Returns/Confirmation");
        setIsLoading(false);
    };

    const handleShippingMethod = (value: string) => {
        setShippingMethod(value);
    };
    const handleFormChange = (e: any) => {
        const { name, value } = e.target;
        setAddressFormData({ ...addressFormData, [name]: value });

        // Error validation logic
        let error = "";
        if (name === "companyName" && value.trim() === "") {
            error = "Company name is required";
        } else if (name === "city" && value.trim() === "") {
            error = "City is required";
        } else if (name === "address1" && value.trim() === "") {
            error = "Address Line 1 is required";
        } else if (name === "postalCode" && value.trim() === "") {
            error = `${PostalCodeName} is required`;
        }
        // Update errors state
        setErrors({ ...errors, [name]: error });
    };
    const handleSuggestionSelection = (selectedAddress: string, address: any[]) => {
        console.log("selectedAddress", selectedAddress, address);
        if (selectedAddress == "provided") {
            addAccount();
        } else {
            proposedAddress(address);
        }
    };
    const gridStyle = {
        display: "inline-grid",
        gridTemplateColumns: "auto auto",
        justifyContent: "center",
        columnGap: "50px",
    };
    return (
        <>
            <StyledWrapper>
                {isLoading && (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <LoadingSpinner {...styles.spinner} />
                    </StyledWrapper>
                )}
                <StyledWrapper {...styles.editHeader}>
                    <StyledWrapper>
                        <Typography {...styles.title} as={"h3"}>
                            {translate("Select Reason For Return")}
                        </Typography>
                    </StyledWrapper>
                    {shippingMethod === "takereturn" && (
                        <StyledWrapper>
                            <Link href="/myAccount/returns/SelectReasons" {...styles.editLink}>
                                EDIT
                            </Link>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
                <StyledWrapper {...styles.editHeader}>
                    <StyledWrapper>
                        <Typography {...styles.title} as={"h3"}>
                            {translate("Confirm Your Return")}
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
                {isApiError && (
                    <FormError
                        returnId={
                            ADIRMAConfirmReturns?.rmaConfirmReturnState?.returnId
                                ? ADIRMAConfirmReturns?.rmaConfirmReturnState?.returnId
                                : ""
                        }
                    />
                )}
                <StyledWrapper>
                    {productsToBeReturned?.map((eachProduct: any) => {
                        const {
                            productDto: {
                                smallImagePath,
                                altText,
                                shortDescription,
                                properties,
                                erpNumber,
                                modelNumber,
                                manufacturerItem,
                                customerName,
                            },
                            canBeReturned,
                            orderNumber,
                        } = eachProduct;
                        return (
                            <GridContainer {...styles.dataContainer}>
                                <GridItem {...styles.imageContainer}>
                                    <Img src={smallImagePath} alt={altText} />
                                </GridItem>
                                <GridItem {...styles.infoContainer}>
                                    <Typography {...styles.descriptionText} as={"h6"}>
                                        {shortDescription}
                                    </Typography>
                                    {properties.branD_PATH && (
                                        <Typography {...styles.smallText}>{properties.branD_SHORTDESC}</Typography>
                                    )}
                                    {erpNumber && <Typography>{erpNumber}</Typography>}
                                    {(modelNumber || manufacturerItem) && (
                                        <Typography>{modelNumber || manufacturerItem}</Typography>
                                    )}
                                </GridItem>
                                <GridItem width={[12, 12, 6, 6, 6]} {...styles.desktopProductInfo}>
                                    <ProductInfo eachProduct={eachProduct} shippingMethod={shippingMethod} />
                                </GridItem>
                            </GridContainer>
                        );
                    })}
                </StyledWrapper>
            </StyledWrapper>
            {returnToBranch && (
                <StyledWrapper {...styles.formWrapper}>
                    <GridContainer {...styles.confirmReturnGridContainer}>
                        <GridItem {...styles.shippingMethodGridItem}>
                            <Typography as="div" {...styles.subHeadings}>
                                {translate("Select Method Of Return *")}
                            </Typography>
                            {/* <Typography {...styles.removeInFutureText}>{translate("Select One *")}</Typography> */}
                            <RadioGroup
                                {...styles.radioGroupDiv}
                                value={shippingMethod}
                                onChangeHandler={event => handleShippingMethod(event.target.value)}
                            >
                                <Radio {...styles.radioButton} key="takeReturn" value="takereturn">
                                    {translate("Take return to any branch")}
                                    {shippingMethod === "takereturn" ? (
                                        <Link
                                            style={{ marginLeft: "15px" }}
                                            onClick={() => {
                                                window.open("/dealerlocator", "_blank");
                                            }}
                                            {...styles.editLink}
                                        >
                                            Branch locator
                                        </Link>
                                    ) : (
                                        <Typography as="div" {...styles.branchLocator}>
                                            {translate("Branch locator")}
                                        </Typography>
                                    )}
                                </Radio>
                                <Radio {...styles.radioButton} key="ship" value="Shipped">
                                    {translate("Ship your return")}
                                </Radio>
                            </RadioGroup>
                        </GridItem>
                        <Typography as="div" {...styles.subHeadings}>
                            {translate("Contact Information")}
                        </Typography>

                        {poFields.map(eachField => {
                            const { type, label, placeholder, error, value, key, maxLength, max, style, errormessage } =
                                eachField;
                            const styleClass: any = style;
                            return (
                                <>
                                    {(type === "text" || type === "number" || type === "email") && (
                                        <GridItem {...styles[styleClass]}>
                                            <TextField
                                                id={key}
                                                label={translate(label)}
                                                onChange={e => {
                                                    handleFormFieldChange(key, e.target.value);
                                                }}
                                                // type={type}
                                                maxLength={maxLength}
                                                max={max}
                                                value={value}
                                                error={
                                                    key === "poNumber" && !isValidPO
                                                        ? `Format: ${poSyntax}  Example: ${getFormatExample()}`
                                                        : error
                                                          ? errormessage
                                                          : error
                                                }
                                                autoComplete="username"
                                                placeholder={translate(placeholder)}
                                            />
                                        </GridItem>
                                    )}
                                </>
                            );
                        })}
                    </GridContainer>
                    {isApiError && (
                        <FormError
                            returnId={
                                ADIRMAConfirmReturns?.rmaConfirmReturnState?.returnId
                                    ? ADIRMAConfirmReturns?.rmaConfirmReturnState?.returnId
                                    : ""
                            }
                        />
                    )}

                    <StyledWrapper {...styles.footerBtnWrapper}>
                        <Button
                            {...styles.cancelReturn}
                            onClick={() => {
                                sessionStorage.removeItem("productsToBeReturned");
                                history.push("/MyAccount/Returns/SelectOrders");
                            }}
                        >
                            {translate("Cancel Return")}
                        </Button>
                        <Button
                            {...(productsToBeReturned?.length > 0 && isValidPO
                                ? styles.continueBtn
                                : styles.disableBtn)}
                            onClick={() => {
                                isValidPO ? submitHandler() : null;
                                
                            }}
                            //  disabled={productsToBeReturned?.length <= 0 || !isFormValid}
                            disabled={ADIRMAConfirmReturns.rmaConfirmReturnState.returnCode == "99" ? true : false}
                        >
                            {translate("Continue")} <Icon color={ADIColors.white} src={ChevronRight} size={15} />
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>
            )}

            {shipToForm && (
                <>
                    <StyledWrapper {...styles.formWrapper}>
                        <GridContainer {...styles.confirmReturnGridContainer}>
                            <Typography as="h6" {...styles.headingAddressForm}>
                                {translate("*Your Return Request Has Been Submitted")}
                            </Typography>
                            <GridWrapper style={gridStyle}>
                                <GridWrapper {...styles.RequestSubmit}>
                                    <Typography>{translate("PO Number")}</Typography>
                                    <Typography>{translate("Name:")}</Typography>
                                    <Typography>{translate("Email Address:")}</Typography>
                                    <Typography>{translate("Business Phone:")}</Typography>
                                    <Typography>{translate("Return Method:")}</Typography>
                                </GridWrapper>
                                <GridWrapper {...styles.RequestSubmit}>
                                    <Typography>
                                        {translate(
                                            `${contactForm[0].value ? contactForm[0].value : number_Po_business?.ponumber}`,
                                        )}
                                    </Typography>
                                    <Typography>
                                        {translate(`${contactForm[1].value} ${contactForm[2].value}`)}
                                    </Typography>
                                    <Typography>{translate(`${contactForm[3].value}`)}</Typography>
                                    <Typography>
                                        {translate(
                                            `${contactForm[4].value ? contactForm[4].value : number_Po_business?.phone}`,
                                        )}
                                    </Typography>
                                    <Typography>{translate("Ship Your Return")}</Typography>
                                </GridWrapper>
                            </GridWrapper>
                        </GridContainer>
                    </StyledWrapper>
                    <StyledWrapper {...styles.formWrapper}>
                        <GridContainer {...styles.confirmReturnGridContainer}>
                            <Typography as="div" {...styles.returnRequestHeading}>
                                {translate("Please Complete The Shipping Label Form Below")}
                            </Typography>
                            <Typography as="div" {...styles.formSubheading}>
                                {translate("Your shipping label will be emailed to you once we you submit this form.")}
                            </Typography>
                            <Typography as="div" {...styles.formSubheading}>
                                {translate("Your return will be complete when we receive your items.")}
                            </Typography>

                            <Typography as="div" {...styles.returnRequestHeading}>
                                {translate("Ship Form Address")}
                            </Typography>
                            <Typography as="div" {...styles.formSubheading}>
                                {translate("*Required Fields")}
                            </Typography>
                            {isApiErrorMessage && (
                                <Typography color="danger" size={14}>
                                    {isApiErrorMessage}
                                </Typography>
                            )}
                            <StyledWrapper {...styles.formSubheading}>
                                {addressValidationErrorMessage &&
                                    addressValidationErrorMessage.map(error => {
                                        return (
                                            <>
                                                {/* <Typography color="danger" size={14}>{translate("* please enter valid address")}</Typography>                    */}
                                                <Typography as="div" color="danger" size={14}>
                                                    {translate(`* ${error}`)}
                                                    <br />
                                                </Typography>
                                            </>
                                        );
                                    })}
                            </StyledWrapper>

                            {addressFields.map(eachField => {
                                const { type, label, placeholder, error, value, key, maxLength, max, style } =
                                    eachField;
                                const styleClass: any = style;
                                return (
                                    <>
                                        {(type === "text" || type === "number" || type === "email") && (
                                            <GridItem {...styles[styleClass]}>
                                                <TextField
                                                    id={key}
                                                    label={label}
                                                    onChange={e => {
                                                        handleFormFieldChange(key, e.target.value);
                                                    }}
                                                    onKeyPress={
                                                        key === "cartons" || key === "cartonsWeight"
                                                            ? e => {
                                                                  // Prevent typing the dot (.) for "cartons" or "cartonsWeight"
                                                                  if (e.key < "0" || e.key > "9") {
                                                                      e.preventDefault();
                                                                  }
                                                              }
                                                            : undefined
                                                    }
                                                    // type={type}
                                                    maxLength={maxLength}
                                                    max={max}
                                                    value={value}
                                                    error={
                                                        key === "poNumber" && !isValidPO
                                                            ? `Fomrat: ${poSyntax}  Example: ${getFormatExample()}`
                                                            : error
                                                    }
                                                    autoComplete="username"
                                                    placeholder={placeholder}
                                                />
                                            </GridItem>
                                        )}
                                        {type === "dropdown" && (
                                            <GridItem {...styles[styleClass]}>
                                                <Select
                                                    id={key}
                                                    {...styles.stateSelect}
                                                    label={label}
                                                    value={selectedState?.name}
                                                    // disabled={validation.state!.isDisabled}
                                                    required
                                                    onChange={handleStateChange}
                                                    data-test-selector="customerAddressForm_state"
                                                >
                                                    <option value="">{translate("Select State")}</option>
                                                    {countrytate?.map((st: string | any) => (
                                                        <option key={st.id} value={st.name}>
                                                            {st.name}
                                                        </option>
                                                    ))}
                                                </Select>
                                            </GridItem>
                                        )}
                                    </>
                                );
                            })}
                        </GridContainer>
                        <StyledWrapper {...styles.fromBottmmessage}>
                            <Icon src={WarningIcon} color="danger" />
                            <Typography>
                                {translate(`${ADIRMAConfirmReturns?.rmaConfirmReturnState?.properties?.returnCharge}`)}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.submitButton}>
                            <Button
                                {...(productsToBeReturned?.length > 0 && isValidPO
                                    ? styles.submitButton
                                    : styles.disableBtn)}
                                // onClick={() => {
                                //     isValidPO ? submitHandler(true) : null;
                                // }}
                                onClick={() => {
                                    HandleValidateAddress(true);
                                }}
                                // disabled={productsToBeReturned?.length <= 0 || !isFormValid}
                            >
                                {translate("Submit")} <Icon color={ADIColors.white} src={ChevronRight} size={15} />
                            </Button>
                        </StyledWrapper>
                    </StyledWrapper>
                </>
            )}

            <ADINewAccountAddressSuggestionModalRecap
                openModal={isAddressSuggestionModalOpen}
                closeModal={useCallback(() => setIsAddressSuggestionModalOpen(false), [isAddressSuggestionModalOpen])}
                closeAddressModal={useCallback(() => false, [])}
                address={addressApiResult.result}
                handleSuggestionSelection={handleSuggestionSelection}
                title="Save Address"
                warningMessage={suggestionWraningMessage}
                apiErrorMessage={isApiErrorMessage}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIReturnSelectOrder),
    definition: {
        group: "Return Request (RMA)",
        icon: "Image",
        displayName: "Return Confirm",
        fieldDefinitions: [],
    },
};

export default widgetModule;
